import { render, staticRenderFns } from "./layout-popup.vue?vue&type=template&id=0ea66c13&scoped=true&"
import script from "./layout-popup.vue?vue&type=script&lang=js&"
export * from "./layout-popup.vue?vue&type=script&lang=js&"
import style0 from "./layout-popup.vue?vue&type=style&index=0&id=0ea66c13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea66c13",
  null
  
)

export default component.exports